import { HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

import { ErrorHandlerHttpInterceptor } from './error-handler.http-interceptor';
import { AuthHttpInterceptor } from './auth.http-interceptor';

/**
 * Interceptor order is load-bearing (Issue #6).
 *
 * Registration order = request-side order, and the response/error side unwinds
 * in reverse. Registering ErrorHandler *before* Auth means Auth sits closer to
 * the backend and therefore sees a 401 first: it can refresh the token and retry
 * transparently, so a successfully repaired request never reaches ErrorHandler.
 * Only an unrecoverable 401 (refresh missing/failed) propagates out to
 * ErrorHandler's logout/redirect fallback. Do not reorder these two without
 * revisiting AuthHttpInterceptor.
 */
export const HttpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS as InjectionToken<HttpInterceptor>, useClass: ErrorHandlerHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS as InjectionToken<HttpInterceptor>, useClass: AuthHttpInterceptor, multi: true }
];
